import React, { useState, useLayoutEffect } from 'react';
import { Link } from 'react-router-dom';

import AnalyticsManager from '@app/analytics/manager';
import { useAbility } from '@app/context/ability-context';
import teacherRoutes from '@app/routes/teacherRoutes';

const getAvailableTabs = (ability) => {
  const baseTabs = [
    teacherRoutes.Home,
    teacherRoutes.Tasks,
  ];

  if (ability.can('read', 'StatisticsPage')) {
    baseTabs.push(teacherRoutes.Statistics);
  }

  if (ability.can('read', 'LeadersPage', 'main')) {
    baseTabs.push(teacherRoutes.Leaders);
  }

  return baseTabs;
};

function getStaticRoutePath(route) {
  const parts = route.split('/').filter(part => part && !part.startsWith(':'));
  return parts.length > 0 ? `/${parts.join('/')}` : null;
}

const NavigationTabs = () => {
  const ability = useAbility();
  const availableTabs = getAvailableTabs(ability);
  const [activeTab, setActiveTab] = useState(availableTabs[0].alias);

  useLayoutEffect(() => {
    const currentPath = window.location.pathname;
    const currentTab = availableTabs.find(tab => {
      const staticPath = getStaticRoutePath(tab.path);
      return staticPath && currentPath.startsWith(staticPath);
    });
    if (currentTab) {
      setActiveTab(currentTab.alias);
    }
  }, []);

  return (
    <div className="tabs-container">
      {availableTabs.map((tab) => (
        <Link
          key={tab.alias}
          to={tab.path}
          className={`tab ${activeTab === tab.alias ? 'active' : ''}`}
          onClick={() => {
            setActiveTab(tab.alias)
            AnalyticsManager.emitPageEvent(`Olymp${tab.alias}Click`)
          }}
        >
          {tab.alias}
        </Link>
      ))}
    </div>
  );
};

export default NavigationTabs;
